import { Injectable } from '@angular/core';
import Dexie from 'dexie';
import { SynchronizationEntity } from '../synchronization/synchronization-entity';
import { LocalDbConsts } from './local-db-consts';
import { Migrator } from './migrator';
import { ActivitySync } from './objects/activity-sync';
import { Example } from './objects/example';
import {
  HarvestActivityReport,
  HarvestActivityReportSyncState,
} from './objects/harvest-activity-report';
import { LocalConfiguration, LocalConfigurationType } from './objects/local-configuration';
import { MachineSync } from './objects/machine-sync';
import { ProgrammingSync } from './objects/programming-sync';
import { ShiftSync } from './objects/shift-sync';
import { SynchronizationStatus } from './objects/synchronization-status';
import { TeamSync } from './objects/team-sync';

@Injectable({
  providedIn: 'root',
})
export class LocalDb extends Dexie {
  exampleTable: Dexie.Table<Example, number>;
  localConfigurations: Dexie.Table<LocalConfiguration, [string, LocalConfigurationType]>;
  harvestActivityReports: Dexie.Table<HarvestActivityReport, number>;
  teams: Dexie.Table<TeamSync, number>;
  shifts: Dexie.Table<ShiftSync, number>;
  activities: Dexie.Table<ActivitySync, number>;
  machines: Dexie.Table<MachineSync, number>;
  programmings: Dexie.Table<ProgrammingSync, number>;
  synchronizationStatus: Dexie.Table<SynchronizationStatus, SynchronizationEntity>;
  harvestActivityReportSyncStates: Dexie.Table<HarvestActivityReportSyncState, number>;

  constructor() {
    super(LocalDbConsts.dbName);

    new Migrator(this).updateDatabase(LocalDbConsts.dbVersion);

    this.on('populate', () => this.seed());

    this.open().catch(error => abp.log.error(error));
  }

  async seed() {
    // await this.harvestActivityReports.bulkAdd(AppConsts.harvestActivityReportsData);
    // await this.harvestActivityReportSyncStates.bulkAdd(
    //   AppConsts.harvestActivityReportsStatusData
    // );
  }
}
